import { ContainerModule, interfaces } from 'inversify';
import { IUserService, UserService } from './user.service';
import { IUserStore, UserStore } from './user.store';

export const userModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(IUserStore.$).to(UserStore).inSingletonScope();
  bind(IUserService.$).to(UserService).inSingletonScope();
});
